import { DataFlag } from './dataFlag.shared.model.js';
import { Goal } from './goal.model.js';
import { ReminderKey } from './reminder.shared.model.js';
export var AppTracker = /*#__PURE__*/function (AppTracker) {
  AppTracker[AppTracker["MENS_QUANTITY"] = 1] = "MENS_QUANTITY";
  AppTracker[AppTracker["CM_CONSISTENCY"] = 2] = "CM_CONSISTENCY";
  AppTracker[AppTracker["CM_QUANTITY"] = 3] = "CM_QUANTITY";
  AppTracker[AppTracker["LIBIDO"] = 4] = "LIBIDO";
  AppTracker[AppTracker["PAIN"] = 5] = "PAIN";
  AppTracker[AppTracker["SKIN"] = 6] = "SKIN";
  AppTracker[AppTracker["MOOD"] = 7] = "MOOD";
  AppTracker[AppTracker["MORE_SEX"] = 8] = "MORE_SEX";
  AppTracker[AppTracker["NOTES"] = 9] = "NOTES";
  AppTracker[AppTracker["SEX"] = 10] = "SEX";
  AppTracker[AppTracker["LH_TEST"] = 11] = "LH_TEST";
  AppTracker[AppTracker["PREG_TEST"] = 12] = "PREG_TEST";
  AppTracker[AppTracker["SLEEP"] = 13] = "SLEEP";
  AppTracker[AppTracker["BREASTFEEDING"] = 14] = "BREASTFEEDING";
  AppTracker[AppTracker["BOTTLE_FEEDING"] = 15] = "BOTTLE_FEEDING";
  AppTracker[AppTracker["PUMPING"] = 16] = "PUMPING";
  AppTracker[AppTracker["LIFESTYLE"] = 17] = "LIFESTYLE";
  AppTracker[AppTracker["EXTERNAL_FACTOR"] = 18] = "EXTERNAL_FACTOR";
  return AppTracker;
}(AppTracker || {});
export const reminderByAppTracker = {
  [AppTracker.LH_TEST]: ReminderKey.checkLH,
  [AppTracker.MOOD]: ReminderKey.pms,
  [AppTracker.PREG_TEST]: ReminderKey.startTesting
};
export const appTrackerByReminder = Object.fromEntries(Object.entries(reminderByAppTracker).map(([key, value]) => [value, Number(key)]));
const preventTrackers = [AppTracker.MENS_QUANTITY, AppTracker.LIBIDO, AppTracker.PAIN, AppTracker.SKIN, AppTracker.MOOD];
const planTrackers = [AppTracker.MENS_QUANTITY, AppTracker.CM_CONSISTENCY, AppTracker.CM_QUANTITY, AppTracker.LIBIDO, AppTracker.PAIN, AppTracker.MOOD];
const pregnantTrackers = [AppTracker.MENS_QUANTITY, AppTracker.CM_CONSISTENCY, AppTracker.CM_QUANTITY, AppTracker.LIBIDO, AppTracker.PAIN, AppTracker.SKIN, AppTracker.MOOD];
const postPartumTrackers = [...preventTrackers, AppTracker.SLEEP, AppTracker.BOTTLE_FEEDING, AppTracker.BREASTFEEDING, AppTracker.PUMPING];
const perimenopauseTrackers = [...preventTrackers, AppTracker.SLEEP, AppTracker.LIFESTYLE, AppTracker.EXTERNAL_FACTOR];
export const defaultAppTrackersByGoal = {
  [Goal.PREVENT]: preventTrackers,
  [Goal.PLAN]: planTrackers,
  [Goal.PREGNANT]: pregnantTrackers,
  [Goal.RECOVERY]: planTrackers,
  [Goal.POSTPARTUM]: postPartumTrackers,
  [Goal.PERIMENOPAUSE]: perimenopauseTrackers
};
export const DEFAULT_DAILY_CHECKIN_SETTINGS = {
  [Goal.PERIMENOPAUSE]: {
    [AppTracker.SLEEP]: true,
    [AppTracker.PAIN]: [DataFlag.PAIN_HOT_FLASHES, DataFlag.PAIN_NIGHT_SWEATS, DataFlag.PAIN_HEART_PALPITATIONS, DataFlag.PAIN_JOINT, DataFlag.PAIN_MIGRAINE, DataFlag.PAIN_INSOMNIA, DataFlag.PAIN_FATIGUE, DataFlag.PAIN_BRAIN_FOG, DataFlag.PAIN_FREQUENT_URINATION, DataFlag.PAIN_BLADDER_LEAKAGE, DataFlag.PAIN_VAGINAL_DRYNESS, DataFlag.PAIN_CRAMPS, DataFlag.PAIN_BACKACHE, DataFlag.PAIN_SORE_BREASTS, DataFlag.PAIN_OVULATION, DataFlag.PAIN_HEADACHE, DataFlag.PAIN_NAUSEOUS, DataFlag.PAIN_DIARRHEA, DataFlag.PAIN_CONSTIPATION, DataFlag.PAIN_BLOATING, DataFlag.PAIN_CRAVINGS, DataFlag.PAIN_OTHER],
    [AppTracker.SKIN]: [],
    [AppTracker.LIFESTYLE]: [DataFlag.LIFESTYLE_ALCOHOL, DataFlag.LIFESTYLE_CAFFEINE, DataFlag.LIFESTYLE_SUGAR, DataFlag.LIFESTYLE_HIGH_FAT_FOOD, DataFlag.LIFESTYLE_SMOKING, DataFlag.LIFESTYLE_STRESS, DataFlag.LIFESTYLE_SUPPLEMENTS, DataFlag.LIFESTYLE_KEGEL_EXERCISE, DataFlag.LIFESTYLE_BREATHING_EXERCISE, DataFlag.LIFESTYLE_JOURNALING, DataFlag.LIFESTYLE_THERAPY, DataFlag.LIFESTYLE_MINDFULNESS],
    [AppTracker.MOOD]: [DataFlag.MOOD_HAPPY, DataFlag.MOOD_CALM, DataFlag.MOOD_SWINGS, DataFlag.MOOD_IRRITABLE, DataFlag.MOOD_ANXIOUS, DataFlag.MOOD_SENSITIVE, DataFlag.MOOD_SAD, DataFlag.MOOD_UNFOCUSED, DataFlag.MOOD_SELF_CRITICAL, DataFlag.MOOD_CONFUSED, DataFlag.MOOD_ISOLATED, DataFlag.MOOD_FEELING_LOW],
    [AppTracker.LIBIDO]: true
  },
  [Goal.POSTPARTUM]: {
    [AppTracker.SLEEP]: true,
    [AppTracker.PAIN]: [DataFlag.PAIN_VAGINAL, DataFlag.PAIN_SORE_NIPPLES, DataFlag.PAIN_BACKACHE, DataFlag.PAIN_HEADACHE],
    [AppTracker.SKIN]: [],
    [AppTracker.LIFESTYLE]: [],
    [AppTracker.MOOD]: [],
    [AppTracker.LIBIDO]: false
  }
};